export interface ChatAppElementModel {
  visible: boolean;
  open: boolean;
  error: boolean;
  loading: boolean;
  initialized: boolean;
  messages: Array<ChatAppMessages>;
  unreadMessageCount: number;
}

export enum ChatAppMessageType {
  Agent = "Agent",
  Bot = "Bot",
  Download = "Download",
  Initialize = "Initialize",
  Links = "Links",
  Options = "Options",
  User = "User",
  Process = "Process",
  SwitchAgent = "SwitchAgent",
  SwitchBot = "SwitchBot",
  Warning = "Warning",
  PollAgent = "PollAgent",
}

export interface ChatAppMessage {
  messageType: ChatAppMessageType;
  parameters?: string;
  currentPage?: string;
  timestamp?: Date;
  agentInfo?: string;
}

export interface ChatAppMessageAgent extends ChatAppMessage {
  messageType: ChatAppMessageType.Agent;
  message: string;
}

export interface ChatAppMessageBot extends ChatAppMessage {
  messageType: ChatAppMessageType.Bot;
  message: string;
}

export interface ChatAppMessageDownload extends ChatAppMessage {
  messageType: ChatAppMessageType.Download;
  fileUrl: string;
  fileName: string;
  fileSize: number;
}

export interface ChatAppMessageInitialize extends ChatAppMessage {
  messageType: ChatAppMessageType.Initialize;
  message: string;
}

export interface ChatAppMessageLinksLink {
  label: string;
  href: string;
  callbackMessage?: string;
}

export interface ChatAppMessageLinks extends ChatAppMessage {
  messageType: ChatAppMessageType.Links;
  links: Array<ChatAppMessageLinksLink>;
}

export interface ChatAppMessageOptionsOption {
  label: string;
}

export interface ChatAppMessageOptions extends ChatAppMessage {
  messageType: ChatAppMessageType.Options;
  options: Array<ChatAppMessageOptionsOption>;
}

export interface ChatAppMessageUser extends ChatAppMessage {
  messageType: ChatAppMessageType.User;
  message: string;
}

export interface ChatAppMessageProcess extends ChatAppMessage {
  messageType: ChatAppMessageType.Process;
}

export interface ChatAppMessageSwitchAgent extends ChatAppMessage {
  messageType: ChatAppMessageType.SwitchAgent;
  message: string;
}

export interface ChatAppMessageSwitchBot extends ChatAppMessage {
  messageType: ChatAppMessageType.SwitchBot;
  message: string;
}

export interface ChatAppMessageWarning extends ChatAppMessage {
  messageType: ChatAppMessageType.Warning;
  message: string;
}

export interface ChatAppMessagePollAgent extends ChatAppMessage {
  messageType: ChatAppMessageType.PollAgent;
  agentInfo: string;
}

export type ChatAppMessages =
  | ChatAppMessageAgent
  | ChatAppMessageBot
  | ChatAppMessageDownload
  | ChatAppMessageInitialize
  | ChatAppMessageLinks
  | ChatAppMessageUser
  | ChatAppMessageOptions
  | ChatAppMessageProcess
  | ChatAppMessageSwitchAgent
  | ChatAppMessageSwitchBot
  | ChatAppMessageWarning
  | ChatAppMessagePollAgent;
